import { MANUAL_IMAGE_CROP_TAG_PREFIX } from "./manualImageCropTagPrefix";
/**
 * Returns the image crop object from an array of image tags
 * Otherwise returns undefined.
 */ export var extractImageCropFromTag = function(tags) {
    if (!tags) {
        return;
    }
    var imageCropTag;
    var manualCropTag = tags.find(function(tag) {
        return tag.startsWith(MANUAL_IMAGE_CROP_TAG_PREFIX);
    });
    if (manualCropTag) {
        imageCropTag = JSON.parse(manualCropTag.replace(MANUAL_IMAGE_CROP_TAG_PREFIX, ""));
    }
    return imageCropTag;
};
